<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: "App",
    components: {
    }
  };
</script>
<style lang="scss">
@import './resourse/iconfont/iconfont.css';
  .view{
    z-index: 4 !important;
  }
  .ivu-table-wrapper{
    overflow: unset !important;
  }
  .ivu-table {
    background-color: #ffffff00 !important;

  }
  .ivu-table:after {
    background-color: #ffffff00 !important;
  }
  .ivu-table:before {
    background-color: #ffffff00 !important;
  }
  .ivu-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
.pagesimg{
  margin: 10px auto;
  text-align: center;
}
.ivu-table th,.ivu-table td{
    text-align: center !important;
}
/* 加载框 */
.gglist{
    position: relative;
    /* height: 100px; */
}
.demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
.top{
    margin: 30px auto;
    margin-bottom: 0;
}

.pages {
    margin: 30px auto;
}
.ivu-modal{
    min-width: 900px !important;
}

.table-content{
    min-width: 800px;
    overflow-x: scroll;
    padding-top: 30px;
}
.ivu-card-body{
    overflow-x: auto;
    height: calc(100vh - 140px);
}
.search-div{
    margin: 5px 0px 10px 0px;
    .input-div{
        width: 200px;
        margin: 5px 5px;
        display: inline-block;
    }
}
@media print {
 .Noprn{ display:none !important;}
}
.ivu-table-cell {
    max-height: 63px;
}
.kong-td{
    text-align: center;
    font-size: 13px;
    padding: 5px 0px;
    font-weight: 600;
    box-sizing: border-box;
}
.ivu-message{
    z-index: 1045 !important;
}
.ivu-tree-title{
  width: 100% !important;
}
.ivu-tree ul li{
  line-height: 41px;
}
.ivu-table-fixed-right,.ivu-table-fixed, .ivu-table-fixed-right{
  box-shadow: none !important;
}
</style>
<style>
.pswp__bg, .pswp__scroll-wrap{
    z-index: -1;
}
</style>

